import React, { Fragment } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Media } from "lib/@types/service/shared";

type DocumentationListProps = {
    docMap: Map<string, Media[]>;
};

const DocumentationList = ({ docMap }: DocumentationListProps) => {
    const { t } = useGranite();
    const renderableDocs = [];

    for (let [key, documents] of docMap) {
        renderableDocs.push((docIndex: number) => {
            return (
                <Fragment key={`doc-${docIndex}`}>
                    {documents.map((document, index) => (
                        <li key={`document-${docIndex}-${index}`}>
                            <a href={document.url} className="btn-link">
                                {t(key)}{" "}
                                {documents.length > 1 ? documents.length : ""}
                            </a>
                        </li>
                    ))}
                </Fragment>
            );
        });
    }

    return <>{renderableDocs.map((d, index) => d(index))}</>;
};

export { DocumentationList };
